import { TreeItemIndex } from 'react-complex-tree'

import type { I18nShape } from '@tribeplatform/react-components/i18n'

import { ShowLessTreeItem } from '../components/ShowLessTreeItem.js'
import { ShowMoreTreeItem } from '../components/ShowMoreTreeItem.js'
import { ShowOrLess, TreeItems } from '../types.js'

export function showOrLessIndex(id: TreeItemIndex) {
  return `show-or-less-${id}`
}

export type showOrLessItemRender = (args: {
  onClick: () => void
}) => React.ReactNode

export function createShowOrLessItem(
  { $t }: I18nShape,
  {
    id,
    showOrLess,
    setShowOrLess,
  }: {
    id: TreeItemIndex
    showOrLess: ShowOrLess
    setShowOrLess: (showOrLess: ShowOrLess) => void
  },
): TreeItems {
  return {
    [showOrLessIndex(id)]: {
      index: showOrLessIndex(id),
      isFolder: false,
      data: {
        title:
          showOrLess === 'show'
            ? ($t({
                id: 'Generics.ShowLess',
                defaultMessage: 'Show less',
              }) as string)
            : ($t({
                id: 'Generics.ShowMore',
                defaultMessage: 'Show more',
              }) as string),
        type: 'simple',
        render: () =>
          showOrLess === 'show' ? (
            <ShowLessTreeItem onClick={() => setShowOrLess('less')} />
          ) : (
            <ShowMoreTreeItem onClick={() => setShowOrLess('show')} />
          ),
      },
    },
  }
}
